import { render, staticRenderFns } from "./SentimentCatIndia.vue?vue&type=template&id=e8ab7c80&scoped=true"
import script from "./SentimentCatIndia.vue?vue&type=script&lang=js"
export * from "./SentimentCatIndia.vue?vue&type=script&lang=js"
import style0 from "./SentimentCatIndia.vue?vue&type=style&index=0&id=e8ab7c80&prod&scoped=true&lang=css"
import style1 from "./SentimentCatIndia.vue?vue&type=style&index=1&id=e8ab7c80&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8ab7c80",
  null
  
)

export default component.exports